export type CtPlatformType =
  'exchange' |
  'wallet' |
  'legacy' |
  'blockchain' |
  'custom' | 'recently_added';

export interface CtPlatformImportType {
  id: number;
  name: CtPlatformImportTypeEnum;
  display_name: string;
}

export enum CtPlatformImportTypeEnum {
  API = 'api',
  CSV = 'csv',
}

export type CtPlatformCredentialType = 'key' | 'secret' | 'key-secret' | 'key-secret-name';

export interface CtPlatformTimeRange extends Record<string, boolean> {
  'start_date': boolean;
  'end_date': boolean;
}

export interface CtPlatformNameMapping extends Record<string, boolean> {
  'custom_name': boolean;
  'label': boolean;
}

export interface CtPlatformOption {
  name?: string;
  display_name?: string;
  description?: string;
  display_position?: number;
  checked_by_default?: boolean;
  disabled?: boolean;
  required?: boolean;
}

export interface CtPlatformBaseItem {
  import_type: CtPlatformImportType;
  name: string;
  display_name: string;
  display_position: number;
  description?: string;
}

export interface CtPlatformItem extends CtPlatformBaseItem {
  credential_type?: CtPlatformCredentialType;
  autosync?: boolean;
  notifications?: boolean;
  timerange?: CtPlatformTimeRange;
  name_mapping?: CtPlatformNameMapping;
  options?: CtPlatformOption[];
  instructions?: string;
}

export interface CtPlatform extends Record<string, unknown> {
  platform_type: CtPlatformType;
  name: string;
  display_name: string;
  description?: string;
  import_instructions?: string;
  logo_uri?: string;
  supported_import_types?: Record<CtPlatformImportTypeEnum, boolean> | null;
  recommended_import_type?: CtPlatformImportType | null;
  uri?: string;
  custom_api_uri: string | null;
  custom_csv_uri: string | null;
  legacy: boolean;
  warningCount: number | null;
}

export interface CtPlatformTypeNetworkResponse {
  data: CtPlatformTypeResponse[];
}
export interface CtPlatformTypeResponse {
  name: CtPlatformType;
  display_name: string;
}

export interface CtPlatformNetworkResponse {
  data: CtPlatform[];
}

export interface GroupedPlatforms {
  label: string;
  items: CtPlatform[];
}

export enum ApiJobStatusEnum {
  PROGRESS = 'progress',
  ACTIVE = 'active',
  ERROR = 'error',
}

export interface ApiJobStatus {
  type: ApiJobStatusEnum;
  message: string | null;
}

export interface CtApiJob {
  id: number;
  credential_type: CtPlatformCredentialType;
  credential_key: string;
  credential_secret: string;
  credential_name: string;
  autosync: boolean;
  custom_name: string | null;
  label: string | null;
  notification: boolean;
  trade_pairs: number;
  startdate: string | null; // Date
  enddate: string | null; // Date
  created: string | null; // Date
  last_sync: string | null; // Date
  last_import: string | null; // Date
  status: ApiJobStatus;
}

export enum ProStatusLevel {
  // GUEST === null
  FREE = 0,
  PRO = 2,
  EXPERT_20K = 4,
  EXPERT_50K = 5,
  EXPERT_100K = 6,
  UNLIMITED = 3,
}

export enum StatusEnum {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  PROGRESS = 'progress',
  ACTIVE = 'active',
  GRAY = 'gray',
  LIGHT_GRAY = 'lightGray',
  LIGHT_GREEN = 'lightGreen',
  GRAY_OUTLINE = 'grayOutline',
  GRAY_OUTLINE_SUCCESS = 'grayOutlineSuccess',
}

export interface MetaData {
  total_item_count: number;
}

export interface TableWrapperProps {
  onLoadCb(info: any): unknown;
  pageSize?: number;
  requestUri?: string;
  onErrorCB?: (e: unknown) => void;
}

export interface UserSettings {
  userId: number | null,
  proStatus: number | null,
  locale: string,
  currency: string,
  dateFormat: string,
  timeFormat: string,
  decimalCharacter: string,
  thousandCharacter: string,
  currencyInUsdRate: number | null,
}
